import { getFunctions, httpsCallable } from "firebase/functions";
import { getUtmSource } from "../../attribution/reader";
import { PaymentInfo, StripePlanId, SubscriptionStatus } from "../types";
import {reportRedditPixelTrial} from "./redditPixelHelper.ts";
import {reportTikTokPixelTrial} from "./tiktokPixelHelper.ts";
import {reportFacebookPixelLead} from "./facebookPixelHelper.ts";
import { reportOpenAiPixelTrialStarted } from "./openAiPixelHelper.ts";
import { DEFAULT_PLAN } from "../plans";
import { captureException } from "../sentry";

const confirmSetupIntent = async (
  setupIntentId: string,
  setupIntentClientSecret: string,
  planId?: StripePlanId
) => {
  try {
    const confirmSubscription = httpsCallable<unknown, null>(
      getFunctions(),
      "http-webOnboardingTrialStart"
    );

    // Omit planId for the control flow; the backend then defaults to annual.
    const result = await confirmSubscription({
      setupIntentId,
      setupIntentClientSecret,
      ...(planId ? { planId } : {}),
    });
    if(result.data) {
      reportRedditPixelTrial(setupIntentId)
      reportTikTokPixelTrial(setupIntentId)
      reportFacebookPixelLead(setupIntentId)
      reportOpenAiPixelTrialStarted(setupIntentId, planId ?? DEFAULT_PLAN.planId)
    }
  } catch (error) {
    captureException(error as Error, { 
      context: 'confirmSetupIntent',
      extra: { setupIntentId }
    });
    return;
  }
};

const getSubscriptionStatus = async () => {
  try {
    const checkSubscriptionFn = httpsCallable<unknown, SubscriptionStatus>(
      getFunctions(),
      "http-webOnboardingSubscriptionStatus"
    );

    // The backend mirrors utm_source into the RevenueCat subscriber
    // ($mediaSource) when it buckets the user, so influencer cohorts can be
    // filtered in Customer Lists.
    const utmSource = getUtmSource();
    const result = await checkSubscriptionFn(utmSource ? { utmSource } : undefined);
    return result.data;
  } catch (error) {
    captureException(error as Error, { 
      context: 'getSubscriptionStatus'
    });
    return null;
  }
};

const generateSubscription = async () => {
  try {
    const callable = httpsCallable<unknown, PaymentInfo>(
      getFunctions(),
      "http-webOnboardingSubscriptionIntent"
    );

    const result = await callable();
    return result.data;
  } catch (error) {
    captureException(error as Error, { 
      context: 'generateSubscription'
    });
    return null;
  }
};

export { generateSubscription, getSubscriptionStatus, confirmSetupIntent };
